import React from "react";
import "../../../styles/About/Route/Intro.scss";

const Intro = () => {
  return (
    <>
      <div className="about-intro">
        <div className="about-intro__container">
          <div className="about-intro__header">
            <h2 className="about-intro__number">
              0<span>1</span>
            </h2>
            <h1 data-aos="fade-down" data-aos-offset="0">
              H<span>ello</span>.
            </h1>
          </div>
          <div className="about-intro__description">
            <p data-aos="fade-right">
              I am <span>Ajay Kumar Jha.</span>
            </p>
            <p data-aos="fade-right" data-aos-delay="200">
              I enjoy building websites and am always enthusiastic about
              creating new features.
            </p>
            <p data-aos="fade-right" data-aos-delay="400">
              Passionate full-stack developer with 2 years of experience in
              building full-stack websites using various tools, frameworks, and
              libraries such as React, Vue, Next.js, and more.
            </p>
            <p data-aos="fade-right" data-aos-delay="600">
              Experienced in leveraging technologies like Node.js,Reactjs,Nextjs,
              MongoDB, and other modern tools to create adaptive and responsive
              applications.
            </p>
            {/* <p data-aos="fade-right" data-aos-delay="800">
              Add more...
            </p> */}

            <div className="about-intro__emoji">:&nbsp;)</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Intro;
